module.exports = __webpack_public_path__ + "7ceb9b69ea3d485cf44ee62c17eff2ff.pdf";